var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBarcode = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H3.27273V11H2V2ZM5.81818 2H6.45455V11H5.81818V2ZM3.90909 2H5.18182V11H3.90909V2ZM14.0909 2H16V11H14.0909V2ZM7.72727 2H9V11H7.72727V2ZM12.1818 2H12.8182V11H12.1818V2ZM9.63636 2H11.5455V11H9.63636V2Z",
    fill: "#042440"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBarcode, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/barcode.ad5aa797.svg";
export { ForwardRef as ReactComponent };